<template>
    <div class="foot" id="app-footer">
        <div class="main" v-html="GLOBAL.sys_bq"></div>
    </div>
</template>

<script>
    export default {
        name: 'app-footer',
        data () {
            return {
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/foot.vue